import React, { useMemo, useState } from "react";
import {
  AppPage,
  MimaButton,
  MimaNewFilter,
  MimaOptionMenu,
  MimaTable,
  MimaText,
} from "../../components";
import moment from "moment";
import constant from "../../utils/constant";
import { AnimatePresence } from "framer-motion";
import {
  CreatePaymentMethodContainer,
  EditPaymentMethodContainer,
  ViewMorePaymentMethodContainer,
} from "../../containers";
import styles from "../../assets/styles/Transaction/Transaction.module.scss";

const PaymentMethod = ({
  isLoading,
  data,
  isFetching,
  onLimitChange,
  limit,
  currentPage,
  searchQuery,
  setCurrentPage,
  setSearchQuery,
  goToCreatePaymentMethod,
  goToEditPaymentMethod,
  createPaymentMethodModal,
  editPaymentMethodModal,
  closeModal,
  filterHandler,
  viewMoreModal,
  goToViewMore,
}) => {
  const [showFilter, setShowFilter] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});

  const filterByData = [{ value: "Date", key: "createdAt" }];

  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original.createdAt;
        return <span>{moment(date).format("DD/MM/YYYY")}</span>;
      },
    },
    {
      Header: "Country Code",
      accessor: "countryCode",
    },
    {
      Header: "Currency Code",
      accessor: "currencyCode",
    },

    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;

        return (
          <MimaOptionMenu
            options={[
              { label: "View More", value: "View More" },
              { label: "Edit Payment Method", value: "Edit Payment Method" },
            ]}
            onOptionSelected={(option) => {
              setSelectedItem(item);
              if (option.value === "View More") {
                goToViewMore();
              } else if (option.value === "Edit Payment Method") {
                goToEditPaymentMethod();
              }
            }}
          />
        );
      },
    },
  ];
  return (
    <AppPage pageTitle="Payment Method">
      <div className={styles.filterClass}>
        {/* <MimaButton
          title={showFilter ? "Close Filter" : "Filter"}
          onClick={() => setShowFilter(!showFilter)}
        /> */}

        <MimaButton
          title="Create Payment Method"
          onClick={goToCreatePaymentMethod}
        />
      </div>

      <MimaNewFilter
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        filterByData={filterByData}
        filterHandler={filterHandler}
      />

      <MimaTable
        tableData={tableData}
        tableColumns={tableColumns}
        searchPlaceholder="Search Payment Method"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />

      {(createPaymentMethodModal ||
        editPaymentMethodModal ||
        viewMoreModal) && (
        <div className="modal">
          <AnimatePresence>
            {createPaymentMethodModal && (
              <CreatePaymentMethodContainer closeModal={closeModal} />
            )}
            {editPaymentMethodModal && (
              <EditPaymentMethodContainer
                closeModal={closeModal}
                selectedItem={selectedItem}
              />
            )}
            {viewMoreModal && (
              <ViewMorePaymentMethodContainer
                closeModal={closeModal}
                selectedItem={selectedItem}
              />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};

export default PaymentMethod;
